var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import BootstrapVue from "bootstrap-vue";
import { storeToRefs } from "pinia";
import Vue, { computed, ref } from "vue";
import { GalaxyApi } from "@/api";
import { useHistoryStore } from "@/stores/historyStore";
import { rethrowSimple } from "@/utils/simple-error";
import {} from "./labels";
import MarkdownSelector from "./MarkdownSelector.vue";
import MarkdownVisualization from "./MarkdownVisualization.vue";
import DataDialog from "@/components/DataDialog/DataDialog.vue";
import BasicSelectionDialog from "@/components/SelectionDialog/BasicSelectionDialog.vue";
import DatasetCollectionDialog from "@/components/SelectionDialog/DatasetCollectionDialog.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MarkdownDialog',
    props: {
        argumentName: { default: undefined },
        argumentType: { default: undefined },
        argumentPayload: { default: undefined },
        labels: null,
        useLabels: { type: Boolean }
    },
    emits: ["onCancel", "onInsert"],
    setup(__props, { emit }) {
        const props = __props;
        Vue.use(BootstrapVue);
        const effectiveLabels = computed(() => {
            if (!props.labels) {
                return [];
            }
            const selectSteps = props.argumentType == "job_id";
            const filteredLabels = [];
            for (const label of props.labels) {
                if (selectSteps && label.type == "step") {
                    filteredLabels.push(label);
                }
                else if (!selectSteps && label.type != "step") {
                    filteredLabels.push(label);
                }
            }
            return filteredLabels;
        });
        const selectorConfig = {
            job_id: {
                labelTitle: "Step",
            },
            invocation_id: {
                labelTitle: "Step",
            },
            history_dataset_id: {
                labelTitle: "Dataset (Input/Output)",
            },
            history_dataset_collection_id: {
                labelTitle: "Dataset Collection (Input/Output)",
            },
        };
        const selectedShow = ref(false);
        const visualizationShow = ref(false);
        const workflowShow = ref(false);
        const historyShow = ref(false);
        const jobShow = ref(false);
        const invocationShow = ref(false);
        const dataShow = ref(false);
        const dataCollectionShow = ref(false);
        const { currentHistoryId } = storeToRefs(useHistoryStore());
        const selectedLabelTitle = computed(() => {
            const config = selectorConfig[props.argumentType];
            return (config && config.labelTitle) || "Select Label";
        });
        function getInvocations() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().GET("/api/invocations");
                if (error) {
                    rethrowSimple(error);
                }
                return data;
            });
        }
        function getJobs() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().GET("/api/jobs");
                if (error) {
                    rethrowSimple(error);
                }
                return data;
            });
        }
        function getWorkflows() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().GET("/api/workflows");
                if (error) {
                    rethrowSimple(error);
                }
                return data;
            });
        }
        function getHistories() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().GET("/api/histories/published");
                if (error) {
                    rethrowSimple(error);
                }
                return data;
            });
        }
        function onData(response) {
            dataShow.value = false;
            emit("onInsert", `${props.argumentName}(history_dataset_id=${response})`);
        }
        function onDataCollection(response) {
            dataCollectionShow.value = false;
            emit("onInsert", `${props.argumentName}(history_dataset_collection_id=${response.id})`);
        }
        function onJob(response) {
            jobShow.value = false;
            emit("onInsert", `${props.argumentName}(job_id=${response.id})`);
        }
        function onInvocation(response) {
            invocationShow.value = false;
            emit("onInsert", `${props.argumentName}(invocation_id=${response.id})`);
        }
        function onHistory(response) {
            historyShow.value = false;
            emit("onInsert", `history_link(history_id=${response.id})`);
        }
        function onWorkflow(response) {
            workflowShow.value = false;
            emit("onInsert", `${props.argumentName}(workflow_id=${response.id})`);
        }
        function onVisualization(response) {
            visualizationShow.value = false;
            emit("onInsert", response);
        }
        function onOk(selectedLabel) {
            const defaultLabelType = ["history_dataset_id", "history_dataset_collection_id"].indexOf(props.argumentType) >= 0 ? "output" : "step";
            const labelText = selectedLabel ? selectedLabel.label : "<ENTER LABEL>";
            const labelType = selectedLabel ? selectedLabel.type : defaultLabelType;
            selectedShow.value = false;
            function onInsertArgument() {
                emit("onInsert", `${props.argumentName}(${labelType}="${labelText}")`);
            }
            if (props.argumentType == "history_dataset_id") {
                if (props.useLabels) {
                    onInsertArgument();
                }
                else {
                    dataShow.value = true;
                }
            }
            else if (props.argumentType == "history_dataset_collection_id") {
                if (props.useLabels) {
                    onInsertArgument();
                }
                else {
                    dataCollectionShow.value = true;
                }
            }
            else if (props.argumentType == "job_id") {
                if (props.useLabels) {
                    onInsertArgument();
                }
                else {
                    jobShow.value = true;
                }
            }
            else if (props.argumentType == "invocation_id") {
                if (props.useLabels) {
                    onInsertArgument();
                }
                else {
                    invocationShow.value = true;
                }
            }
        }
        function onCancel() {
            dataCollectionShow.value = false;
            selectedShow.value = false;
            workflowShow.value = false;
            visualizationShow.value = false;
            jobShow.value = false;
            invocationShow.value = false;
            dataShow.value = false;
            emit("onCancel");
        }
        if (props.argumentType == "workflow_id") {
            workflowShow.value = true;
        }
        else if (props.argumentType == "history_id") {
            historyShow.value = true;
        }
        else if (props.argumentType == "history_dataset_id") {
            if (props.useLabels) {
                selectedShow.value = true;
            }
            else {
                dataShow.value = true;
            }
        }
        else if (props.argumentType == "history_dataset_collection_id") {
            if (props.useLabels) {
                selectedShow.value = true;
            }
            else {
                dataCollectionShow.value = true;
            }
        }
        else if (props.argumentType == "invocation_id") {
            if (props.useLabels) {
                selectedShow.value = true;
            }
            else {
                invocationShow.value = true;
            }
        }
        else if (props.argumentType == "job_id") {
            if (props.useLabels) {
                selectedShow.value = true;
            }
            else {
                jobShow.value = true;
            }
        }
        else if (props.argumentType == "visualization_id") {
            visualizationShow.value = true;
        }
        return { __sfc: true, props, emit, effectiveLabels, selectorConfig, selectedShow, visualizationShow, workflowShow, historyShow, jobShow, invocationShow, dataShow, dataCollectionShow, currentHistoryId, selectedLabelTitle, getInvocations, getJobs, getWorkflows, getHistories, onData, onDataCollection, onJob, onInvocation, onHistory, onWorkflow, onVisualization, onOk, onCancel, MarkdownSelector, MarkdownVisualization, DataDialog, BasicSelectionDialog, DatasetCollectionDialog };
    }
});
